import React from 'react';
import Loader from '../../components/common/loader';

const EditBackRoute: React.FC = () => {
  /* Placeholder for any "back-step" UI -- for now this is a simple loading state */
  return (
    <Loader
      text={'Saving changes...'}
      mode="indeterminate"
      showHeaderFooter={false}
      speed={2.0}
    />
  );
};

export default EditBackRoute;
